import { ListOption } from "./Interfaces/listOption";

export const CANADIAN_PROVINCES: ListOption[] = [
  { id: 1, name: "British Columbia" },
  { id: 2, name: "Alberta" },
  { id: 3, name: "Saskatchewan" },
  { id: 4, name: "Manitoba" },
  { id: 5, name: "Ontario" },
  { id: 6, name: "Quebec" },
  { id: 7, name: "Newfoundland and Labrador" },
  { id: 8, name: "Prince Edward Island" },
  { id: 9, name: "Nova Scotia" },
  { id: 10, name: "New Brunswick" },
  { id: 11, name: "Yukon" },
  { id: 12, name: "Northwest Territories" },
  { id: 13, name: "Nunavut" },
];

export function getProvinces(): Promise<ListOption[]> {
  return new Promise((resolve) => {
    setTimeout(
      () => {
        resolve([...CANADIAN_PROVINCES, { id: 14, name: "Other" }]);
        // TODO this should be an API call to get the provinces, but hardcoded on the frontend for now. We can simulate an API call here so the change won't be different to the end user.
      },
      Math.random() * 300 + 150,
    );
  });
}
